import { Input, IModalAction, TModalCustomView } from '@ws/shared/components';
import { useEffect, useRef, useState } from 'react';

import { isMobile } from '../../../../modules/getResolution';
import { getNowAndAName } from '../../../../utils/getNowAndAName';

function getName(entityType: string) {
  let name = '';

  switch (entityType) {
    case 'note':
      name = 'заметку';
      break;
    case 'collection':
      name = 'коллекцию';
      break;
    default:
      name = '';
  }

  return `Создаём ${name}`;
}

export function showEntityCreationModal(
  entityType: string,
  createFunc: (text: string) => void,
  createAndGoFunc: (text: string) => void,
  resolution: string,
): TModalCustomView {
  return function EntityCreationModal({
    closeAllModals,
    onAwayClose,
    actionHandlerCreator,
    components: {
      ModalWrapper,
      ModalContentWrapper,
      ModalCloseButton,
      ModalTitle,
      ModalSubTitle,
      ModalContent,
      ButtonsPanel,
    },
  }) {
    const inputRef = useRef<HTMLInputElement>(null);
    const { augmentedName } = getNowAndAName();
    const [text, setText] = useState(augmentedName);
    const mobile = isMobile(resolution);
    const baseButtons: IModalAction[] = [
      {
        text: 'Создать',
        color: 'secondary',
        onClick: actionHandlerCreator(() => createFunc(text)),
      },
      {
        text: 'Создать и перейти',
        onClick: actionHandlerCreator(() => createAndGoFunc(text)),
      },
    ];
    const isNotMobileButtons: IModalAction[] = mobile
      ? []
      : [{ text: 'Отмена', color: 'tertiary', onClick: closeAllModals }];

    useEffect(() => {
      inputRef.current?.select();
    }, []);

    return (
      <ModalWrapper onClick={onAwayClose}>
        <ModalContentWrapper>
          <ModalCloseButton onClose={closeAllModals} />
          <ModalTitle>{getName(entityType)}</ModalTitle>
          <ModalSubTitle>Введите название</ModalSubTitle>
          <ModalContent>
            <Input ref={inputRef} value={text} onChange={(event) => setText(event.target.value)} />
          </ModalContent>

          <ButtonsPanel actions={[...isNotMobileButtons, ...baseButtons]} />
        </ModalContentWrapper>
      </ModalWrapper>
    );
  };
}
